import { Locale } from 'types/Locale'

export const getFormatVolume = (locale: Locale) =>
  // HACK Not taking locale into account here, as the Swiss German locale will
  // use periods as decimal seperators, while Tages-Anzeiger Style Guide
  // prescribes the use of commas.
  // The Swiss French locale is properly formatted for our purposes.
  Intl.NumberFormat(`fr-CH`, {
    maximumSignificantDigits: 3
  })
